import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Components from '../../../components'
import Client from '../../../services'
import EnrollCourse from './EnrollCourse'
import NewExamForm from './NewExamForm'

const BASE_CLASSNAME = "course-details"

const studentTableheaderMap = {
    "index": {label: "Sl.No.",},
    "_id": {label: "Enrollment Id",},
    "username": {label: "Student Id",},
    "name": {label: "Name",},
    "address": {label: "Address",},
    "contact": {label: "Contact",},
}

const examTableheaderMap = {
    "index": {label: "Sl.No.",},
    "title": {label: "Name",},
    "fullMarks": {label: "Full Marks"},
    nQuestions: {label: "No. of Questions"},
    duration: {label: "duration"},
    fm_nq: {label: <>FM/N/Dur</>},
    "_by": {label: "Created By",},
    "createdAt": {label: "Created At"}
}

const courseBatchTableHeaderMap = {
    "index": {label: "Sl. No."},
    "_id": {label: "Id"},
    "courseTitle": {label: "Course Name"},
    "title": {label: "Batch Name"},
    "description": {label: "Description"},
    "nStudents": {label: "No of Students"},
    "nTeachers": {label: "No of Teachers"},
    "actions": {label: "Actions"},
}

class CourseDetails extends React.Component{
    state = {
        creator: {},
        school: {},
        course: {},
        courseBatches: [],
        students: [],
        exams: []
    }
    componentDidMount(){
        this.loadDetails()
        this.loadStudents()
        this.loadExams()
        this.loadCourseBatches()
    }

    loadDetails = async () => {
        const {id} = this.props.match.params
        const {success, data, message} = await Client.api.get(`/common/course/${id}`)
        if(success){
            const {_by: creator, _sid: school, ...course} = data
            console.log({ creator, course})
            this.setState({
                creator, course
            })
        }else{
            Client.alert.fire({
                icon: "failure",
                title: "Loading failed",
                body: message,
                confirmButton: true,
            })
        }
    }

    loadExams = async () => {
        const {id} = this.props.match.params
        const {success, data, message} = await Client.api.get(`/management/exam/list?_cid=${id}`)
        if(success){
            console.log(data)
            const list = data.map((v, i) => {
                return {
                    index: i+1,
                    title: v.title,
                    fullMarks: v.fullMarks,
                    nQuestions: v.nQuestions,
                    duration: v.examDuration,
                    fm_nq: `${v.fullMarks}/${v.nQuestions}/${v.examDuration}`,
                    createdAt: new Date(v.createdAt).toLocaleString(),
                    _by: <>
                        <div>
                            {v._by.name}
                        </div>
                        <div>
                            {v._by.username}
                        </div>
                    </>
                }
            })
            console.log({exam: list})
            this.setState({
                exams: list
            })
        }
    }

    loadStudents = async () => {
        const {id} = this.props.match.params
        const {success, data, message} = await Client.api.get(`/management/course/${id}/students`)
        if(success){
            const list = data.map((v, i) => {
                console.log("student",v)
                return {
                    index: i+1,
                    _id: v._id,
                    name: v._uid.name,
                    username: v._uid.username,
                    address: v.address
                }
            })
            this.setState({
                students: list
            })
        }
    }

    loadCourseBatches = async () => {
        const {id} = this.props.match.params
        const {success, data} = await Client.api.get(`/management/course/batch/list?_cid=${id}`)
        if(success){
            const newList = data.map((v,i) => {
                const {_cid:course, ...batch} = v
                return {
                    ...batch,
                    course,
                    title:  <Link to={`/management/course-batch/${v._id}`}>{course.title}</Link>,
                    courseTitle: course.title,
                    index: i+1, 
                    actions: <button onClick={(e)=>this.props.history.push(`/management/course-batch/${v._id}`)} >View</button>}
            })
            console.log(newList)
            this.setState({
                courseBatches: newList
            })
    
        }else{
            this.setState({
                courseBatches: []
            })
        }

    }

    handleEnrollStudent = (e) => {
        e.preventDefault()
        let studentId = ""
        let feesDueDate = ""
        let monthlyFees = this.state.course.cost
        const handleClickStudent = (id) => studentId = id
        const handleChangeFirstDueDate = (value) => feesDueDate = value
        const handleChangeMonthlyFees = (value) => monthlyFees = value
        Client.alert.fire({
            title: "Enroll Student",
            body: <EnrollCourse 
                courseFees={this.state.course.cost}
                onChangeMonthlyFees={handleChangeMonthlyFees}
                onClickStudent={handleClickStudent} 
                courseStartingFrom={Client.utility.getFormattedDateYYYYMMDD(this.state.course.startingFrom)}
                onChageDueDate={handleChangeFirstDueDate}
            />,
            confirmButton: true,
            cancelButton: true,
            confirmButtonText: "Submit",
            preConfirm: async () => {
                const {batch} = this.state
                const {id} = this.props.match.params

                const payload = {
                    studentId: studentId.trim(),
                    courseId: id.trim(),
                    feesDueDate,
                    monthlyFees
                }
                const {success, data, message} = await Client.api.post(`/management/student/enroll`, payload)
                if (success){
                    const newEnrollment = {
                        index: this.state.students.length + 1,
                        _id: data.courseEnrollment._id,
                        username: data.courseEnrollment._uid.username,
                        name: data.courseEnrollment._uid.name,
                    }
                    this.setState({students: [...this.state.students, newEnrollment]})
                    await Client.alert.fire({
                        title: "Success",
                        body: message || "Student enrolled succesfully.",
                        confirmButton: true,
                    })
                    
                }else{
                    Client.alert.fire({
                        title: "Failed",
                        body: message || "failed to enroll student.",
                        confirmButton: true
                    })
                }
            }
        })
    }

    handleNewExam = (e) => {
        e.preventDefault()
        const inputs = {
            title: "",
            fullMarks: "100",
            nQuestions: "10",
            examDuration: "60",
        }
        
        const handleFieldChange = (name, value) => {
            inputs[name] = value
        }

        Client.alert.fire({
            title: "Create New Exam",
            body: <NewExamForm 
                course={this.state.course}
                onChange={handleFieldChange}
            />,
            confirmButton: true,
            cancelButton: true,
            confirmButtonText: "Submit",
            preConfirm: async () => {
                const payload = {
                    ...inputs,
                    
                    fullMarks: Number(inputs.fullMarks),
                    nQuestions: Number(inputs.nQuestions),
                    examDuration: Number(inputs.examDuration),
                    _cid: this.state.course._id
                }
                const {success, data, message} = await Client.api.post(`/management/exam/new`, payload)
                if (success){
                    
                    await Client.alert.fire({
                        title: "Success",
                        body: message || "Exam created succesfully.",
                        confirmButton: true,
                    })
                    
                }else{
                    Client.alert.fire({
                        title: "Failed",
                        body: message || "failed to create exam.",
                        confirmButton: true
                    })
                }
            }
        })
    }

    handleCreateNewBatch = () => {
        const {id} = this.props.match.params
        this.props.history.push('/management/course-batch/create?cid='+id)
    }

    render(){
        const studentTableHeaderCols = ["index", "username", "name", "address", "contact"]
        const examTableHeaderCols = ["index", "title", "fm_nq", "_by"]
        const courseBatchTableHeaderCols = ["index", "title", "description"]
        const {school, course} = this.state
        return <div className={`${BASE_CLASSNAME} student-batch-details`}>
            <section className='u-flex'>
                <title>Course Details</title>
            </section>
            
            <div className='u-flex'>
                <div className='u-flex--2'>
                    <section className={`${BASE_CLASSNAME}__info`}>
                        <div className={`${BASE_CLASSNAME}__info-title`}>
                            <div>{course.title}</div>
                            <div>INR {course.cost}/month</div>
                        </div>
                        <div className={`${BASE_CLASSNAME}__info-basic`}>
                            <div>
                                <div className={`${BASE_CLASSNAME}__info-value`}>
                                    <div>
                                        No of Levels:
                                    </div>
                                    <div>
                                        {course.nLevel}</div>
                                    </div>
                                <div className={`${BASE_CLASSNAME}__info-value`}>
                                    <div>
                                        Duration:
                                    </div>
                                    <div>
                                        {course.duration} months/level</div>
                                    </div>
                                <div className={`${BASE_CLASSNAME}__info-value`}>
                                    <div>
                                        Fees:
                                    </div>
                                    <div>
                                        INR {course.cost}/month</div>
                                    </div>
                                <div className={`${BASE_CLASSNAME}__info-value`}>
                                    <div>
                                        Starting Date:
                                    </div>
                                    <div>
                                        {new Date(course.startingFrom).toDateString()}</div>
                                    </div>
                            </div>
                            <div className={`${BASE_CLASSNAME}__info-value`} style={{flexDirection: 'column', alignItems: "flex-start"}}>
                                <div>Course Description</div>
                                <div>
                                    {course.description}
                                </div>
                            </div>

                        </div>
                    </section>
                    <section className={`${BASE_CLASSNAME}__student-list`}>
                        <title className='u-flex'>
                            Student List
                            <div className='u-flex--1'></div>
                            <Components.buttons.FlatButton onClick={this.handleEnrollStudent}>+ Add</Components.buttons.FlatButton>
                        </title>
                        <Components.data.Table
                            containerStyle={{display: "flex"}}
                            headerMap={studentTableheaderMap}
                            headers={studentTableHeaderCols}
                            data={this.state.students}
                        />
                    </section>
                    
                </div>

                <div className='u-flex--1'>
                    <section>
                        <title className='u-flex'>
                            Course Batch List
                            <div className='u-flex--1'></div>
                            <Components.buttons.FlatButton onClick={this.handleCreateNewBatch}>+ New</Components.buttons.FlatButton>
                        </title>
                        <Components.data.Table 
                            containerStyle={{display: "flex", height: "35vh"}}
                            headerMap={courseBatchTableHeaderMap}
                            headers={courseBatchTableHeaderCols}
                            data={this.state.courseBatches}
                        />
                    </section>
                    <section>
                        <title className='u-flex'>
                            Exam List
                            <div className='u-flex--1'></div>
                            <Components.buttons.FlatButton onClick={this.handleNewExam}>+ New</Components.buttons.FlatButton>
                        </title>
                        <Components.data.Table 
                            containerStyle={{display: "flex", height: "35vh"}}
                            headerMap={examTableheaderMap}
                            headers={examTableHeaderCols}
                            data={this.state.exams}
                        />
                    </section>
                    
                </div>
            </div>
        </div>
    }
}

export default CourseDetails